import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import cn from './style.module.sass';

export const SkipNavLink: React.FC<{
	targetId?: string;
	position?: string;
	children?: React.ReactNode;
}> = ({ targetId = 'main-content', position, children }) => {
	const { i18n } = useTranslation();
	const linkText = children || i18n.t('accessibility.skipNav');

	return (
		<a
			href={`#${targetId}`}
			className={clsx(cn.skip)}
			aria-label={i18n.t('accessibility.skipToContentLabel')}
			aria-describedby={i18n.t('accessibility.skipToContentLabel')}
			onClick={(e) => {
				e.preventDefault();
				const targetElement = document.getElementById(targetId);

				if (targetElement) {
					targetElement.setAttribute('tabindex', '-1');
					targetElement.focus();
					setTimeout(() => targetElement.removeAttribute('tabindex'), 100);
				}
			}}
		>
			{linkText}
		</a>
	);
};

export const SkipNavContent: React.FC<{
	id?: string;
	children?: React.ReactNode;
}> = ({ id = 'main-content', children }) => {
	return <div className="min-h-fit flex-1" id={id} role="main">{children}</div>;
};